"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var createClassNames = function createClassNames(classNamesObject) {
  var classNames = [];
  Object.keys(classNamesObject).forEach(function (key) {
    if (classNamesObject[key]) {
      classNames.push(key);
    }
  });
  return classNames.join(' ');
};

var CarouselSlide = function CarouselSlide(_ref) {
  var active = _ref.active,
      animateIn = _ref.animateIn,
      animateOut = _ref.animateOut,
      direction = _ref.direction,
      index = _ref.index,
      onCarouselClick = _ref.onCarouselClick,
      showZoomOverlay = _ref.showZoomOverlay,
      zoomOverlayContent = _ref.zoomOverlayContent,
      props = _objectWithoutProperties(_ref, ["active", "animateIn", "animateOut", "direction", "index", "onCarouselClick", "showZoomOverlay", "zoomOverlayContent"]);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentDirection = _useState2[0],
      setDirection = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      classes = _useState4[0],
      setClasses = _useState4[1];

  var startAnimation = (0, _react.useCallback)(function () {
    var newDirection = direction === 'prev' ? 'right' : 'left';
    setDirection(newDirection);
  }, [direction, setDirection]);
  (0, _react.useEffect)(function () {
    var initialClasses = {
      item: true,
      clickable: onCarouselClick && active && !animateIn,
      active: active && !animateIn || animateOut,
      'overlay-container': showZoomOverlay
    };

    if (direction && active && animateIn) {
      initialClasses[direction] = true;
    }

    if (currentDirection && (animateIn || animateOut)) {
      initialClasses[currentDirection] = true;
    }

    setClasses(initialClasses);
  }, [onCarouselClick, active, animateIn, animateOut, showZoomOverlay, direction, currentDirection]);
  (0, _react.useEffect)(function () {
    setDirection(null);
    setTimeout(function () {
      return startAnimation();
    }, 20);
  }, [active, startAnimation]);

  var onClick = function onClick() {
    onCarouselClick && onCarouselClick(index);
  };

  var zoomContent = zoomOverlayContent || _react["default"].createElement("span", null, "Zoom In");

  return _react["default"].createElement("div", {
    onClick: onClick,
    className: createClassNames(classes)
  }, props.children, showZoomOverlay ? _react["default"].createElement("div", {
    className: "overlay flex-center",
    style: {
      color: _colors.teal.base
    }
  }, zoomContent) : null);
};

CarouselSlide.propTypes = {
  active: _propTypes["default"].bool,
  index: _propTypes["default"].number,
  animateOut: _propTypes["default"].bool,
  animateIn: _propTypes["default"].bool,
  direction: _propTypes["default"].string,
  onCarouselClick: _propTypes["default"].func,
  showZoomOverlay: _propTypes["default"].bool,
  zoomOverlayContent: _propTypes["default"].node,
  children: _propTypes["default"].node
};
var _default = CarouselSlide;
exports["default"] = _default;